import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }

import { computed } from 'vue'
import { BfProgress } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useProgressStore } from '@/store/progressStore'
import { ProgressStep } from '@finetic/bikefitting-ui/dist/types/progressTypes'


export default /*@__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

const { t } = useI18n()

const progressStore = useProgressStore()
const { getStep } = storeToRefs(progressStore)

const steps = computed<ProgressStep[]>(() => [
  { title: t('steps.start') },
  { title: t('steps.setup') },
  { title: t('steps.analysis') },
  { title: t('steps.data') },
  { title: t('steps.completion') },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BfProgress), {
      class: "progress-bar",
      steps: steps.value,
      "current-step": _unref(getStep)
    }, null, 8, ["steps", "current-step"])
  ]))
}
}

})